<template>
  <div class="inventory--alternative-tab">
    <b-row class="alternative-grid-header">
      <b-col cols="12">
        <b-form-checkbox v-model="isShowTransactions" name="check-button" switch>
          Show transaction items
        </b-form-checkbox>
        <div class="pull-right tools">
          <b-button @click="$bvModal.show('import-company-part-modal')" size="sm" variant="primary">
            <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import Excess Parts
          </b-button>
        </div>
        <add-company-parts @refreshGrid="getGridList" :companyInfo="companyInfo" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :gridId="gridId"
          :itemData="itemData"
          :fields="fields"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="onEdit"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :styleCustom="'height: 210px'"
          :isTblLoader="tblLoader"
          @getData="onGetData"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';
import AddCompanyParts from './components/Add';

export default {
  // name: 'Company Part Numbers',
  components: {
    AddCompanyParts,
    GridSettings,
    GridComponent
  },
  props: {
    partId: [Number, String],
    companyId: [Number, String],
    companyInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fields: gridFields,
      gridId: GRID_ID.COMPANY_PARTS_LIST,
      selectedRowItemId: 0,
      isShowTransactions: false,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
    };
  },
  computed: {
    ...mapGetters('companyParts', [
      'gridList',
      'pageInfo',
      'filters',
      'lastOpenedId',
      'tblLoader',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
      return this.gridList.filter(x => x.isImport || x.isImport == !this.isShowTransactions).map((item) => ({ ...item, selected: item.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapMutations('companyParts',['setItem']),
    ...mapActions('companyParts', ['getAll', 'sortGrid', 'search', 'deleteRecord']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onEdit(row) {
      this.setItem({ resource: 'lastOpenedId', payload: row.id });
    },
    async onDelete(rma) {
      const deleteConfirmed = await this.openConfirmBox({});
      if (deleteConfirmed) {
        await this.deleteRecord(rma.id);
        this.getAll({});
      }
    },
    getGridList(){
      this.search(this.filters)
    },
    async onGetData(params) {
      await this.getAll(params);
    }
  },
  watch: {
    // async gridList() {
    //   //This function sets the first row as the selected row
    //   this.selectedRowItemId = await this.setSelectedRowId(this.gridList,this.selectedRowItemId,this.lastOpenedId);
    // },
    partId(newPartId){
      // this.filters.partId = newPartId;
      this.setItem({ resource: 'filters', payload: {...this.filters, partId: newPartId} });
      // this.getGridList()
    },
    companyId(newCompanyId){
      // this.filters.companyId = newCompanyId;
      this.setItem({ resource: 'filters', payload: {...this.filters, companyId: newCompanyId} });
      // this.getGridList()
    },
    filters() {
      this.getAll({});
    }
  },
  mounted() {
    this.setItem({ resource: 'filters', payload: { partId: this.partId, companyId: this.companyId } });
    // this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    // this.getGridList()
  },
};
</script>

<style lang="scss">
.inventory--alternative-tab {
  .alternative-grid-header {
    margin-bottom: 5px;
  }
}
</style>
